import React from "react";
import "./index.css";
import { ErrorMessage, Field, useField } from "formik";

const CustomDate = ({ label, name, checkForCheckoutPage, inputClass, placeholder, ...props }) => {
    const [field, meta] = useField({ name, ...props });

    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split("T")[0];

    return (
        <div className="form-group">
            <label htmlFor={name} onClick={() => document.getElementById(name)?.focus()}>
                {label}
            </label>
            <Field
                type="date"
                id={name}
                name={name}
                max={today} 
                placeholder={placeholder}
                readOnly={checkForCheckoutPage}
                className={`custom-input ${inputClass ? "input_required" : ""} ${meta.touched && meta.error ? "is-invalid" : ""}`}
            />
            <ErrorMessage name={name} component="div" className="error-message" />
        </div>
    );
};

export default CustomDate;
